export default (function () {

  /**
   * toggle sidebar
   *
   */
  if (document.querySelector('.js-togglesidebar') != undefined && document.querySelector('.js-togglesidebar') != null) {
    document.querySelector('.js-togglesidebar').addEventListener('change', (e) => {
      if (e.target.checked) {
        document.querySelector('.p-archive__list').classList.add('is-sidebarHidden');
      } else {
        document.querySelector('.p-archive__list').classList.remove('is-sidebarHidden');
      }
    });
  }


})();
